<script lang="ts">
  import { t } from "$lib/i18n/translations";
  import { base } from "$app/paths";
  import GoogleAdSense from "$components/adSense/googleAdSense.svelte";
  import { WEB_SHOW_ADSENCE }from "$env/static/public";
  const cards = [
    {
      title: "general.about.videos.card1.title",
      alt: "general.about.videos.card1.alt",
      description: "general.about.videos.card1.description",
      image: base + "/images/videos-phone.png",
    },
    {
      title: "general.about.videos.card2.title",
      alt: "general.about.videos.card2.alt",
      description: "general.about.videos.card2.description",
      image: base + "/images/videos-pc.png",
    },
    {
      title: "general.about.videos.card3.title",
      alt: "general.about.videos.card3.alt",
      description: "general.about.videos.card3.description",
      image: base + "/images/videos-iphone.png",
    },
  ];
</script>

<!-- 内容介绍 -->
<section class="w-full max-mobile:bg-[#EAF0FD]">
  <div
    class="max-w-[1312px] mx-auto w-full w-full flex flex-col items-center justify-center px-[16px]"
  >
    <!-- 标题 -->
    <div class="mt-[100px] text-center max-w-[1000px] max-mobile:mt-[40px]">
      <h2 class="!text-[36px] !font-bold !leading-normal !mb-4 max-mobile:!text-[20px]">
        {$t("general.about.videos.title")}
      </h2>
      <div class="text-[18px] leading-normal text-[#808080] max-mobile:text-[14px]">
        {$t("general.about.videos.description")}
      </div>
    </div>

    <div class="mt-11 grid grid-cols-3 gap-[25px] max-w-[1280px] w-full  max-mobile:grid-cols-1 max-mobile:mt-3 max-mobile:mb-[40px] max-mobile:gap-6">
      {#each cards as card, index}
        <article class="flex flex-col max-mobile:bg-white max-mobile:rounded-[16px]">
          <div class="h-[320px]">
            <img
              src={card.image}
              alt={$t(card.alt)}
              class="h-full w-full object-cover rounded-[16px]"
              loading="lazy"
            />
          </div>
          <div class="mt-[32px] leading-[1.5]  max-mobile:p-4  max-mobile:mt-0">
            <h3 class="!text-[24px] !mb-6 max-mobile:!text-[16px] max-mobile:!font-bold max-mobile:!mb-3">
              {$t(card.title)}
            </h3>
            <p class="text-[18px] whitespace-pre-wrap max-mobile:text-[14px]">
              {$t(card.description)}
            </p>
          </div>
        </article>
      {/each}
    </div>
  </div>
</section>
{#if WEB_SHOW_ADSENCE === "true" }
<section class="w-full max-mobile:bg-[#EAF0FD]">
  <div class="max-w-[1100px] mx-auto w-full w-full my-[100px] max-mobile:my-0">
    <GoogleAdSense type="crosswise"/>
  </div>
</section>
{/if}
